export const GetConvertInitial = "/Trade/GetConvertInitial";

export const ConvertInsertInitial = "/Trade/ConvertInsertInitial";

export const ConvertInsertConfirmedUser = "/Trade/ConvertInsertConfirmedUser";

export const GetConvertAmountMax = ({ coinId, coinMasterId, sideId }) =>
  `/Trade/GetConvertAmountMax?CoinId=${coinId}&CoinMasterId=${coinMasterId}&SideId=${sideId}`;
